/*eslint-disable */

import axios from 'axios';
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 
export default {
  name: 'blocked-user-list',
  components: {},
  props: [],
  data () {
    return {
      blockUserList:null,
      nextStep:'',
      blockUserListResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
    }
  },
  computed: {
  ...mapGetters([
    'getBlockGetters'
  ]),
  getblockUserListDetailsFun(){
     this.blockUserList = this.$store.getters.getBlockGetters.data;
     return
  },
  SetIntialStatus() {
    if (this.blockUserList) {
      this.nextStep = this.blockUserList.next
      this.blockUserListResults = this.blockUserList.results
    }
  },
  },
  mounted () {
    this.getblockUserListDetailsFun
    this.SetIntialStatus
  },
  methods: {
    getAgainBlockedUserList(){
      this.$store.dispatch('getBlockUserFun')
      .then((res) => {
      }).catch((err) => {
      })
    },
    unBlockedRequestSend(id){
      this.userLoading = true
      this.$store.dispatch('unBlockUserFun', {id:id} )
      .then((res) => {
        this.getAgainBlockedUserList()
        toast.success(res.data.msg);  
        this.userLoading = false
      }).catch((err) => {
        toast.error(err.data.msg);
      })
    }
  },
  watch:{
    getblockUserListDetailsFun(){
      return this.$store.getters.getBlockGetters;
    },
    SetIntialStatus() {
      if (this.blockUserList) {
        this.nextStep = this.blockUserList.next
        this.blockUserListResults = this.blockUserList.results
      }
    },
  }
}


